import { Validators } from '@angular/forms';
import { FormConfig } from '../edit-create-form.interfaces';
import { DEFAULT_COLOR_PRESET_CONFIG } from '@shared/components/generic-colorpreset/generic-colorpreset.configs';
import { DEFAULT_TAG_COLOR_CONFIG, DEFAULT_TAG_TEXT_COLOR_CONFIG } from '@shared/components/generic-colorpicker/generic-colorpicker.configs';

export const courseLevelFormConfig = (): FormConfig => {
  return {
    fields: [
      {
        key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'code', label: 'Mã level', required: true, width: 'half',
        type: 'text', validators: [Validators.pattern(/^[a-z0-9-]+$/)],
        placeholder: 'Chữ thường, số, dấu gạch ngang',
        tooltip: (editMode: boolean, formValue: any) =>
          editMode && formValue.code ? 'Không thể sửa mã level đã có' : '',
        customErrorMessage: 'Mã level là bắt buộc và chỉ chứa chữ thường, số, dấu gạch ngang',
        disabled: (editMode: boolean, formValue: any) => editMode && formValue.code
      },
      {
        key: 'name', label: 'Tên level', required: true, width: 'half',
        type: 'text', placeholder: 'Nhập tên level'
      },
      {
        key: 'sortIndex', label: 'Thứ tự sort', width: 'half',
        type: 'text', placeholder: 'Thứ tự sort',
        validators: [Validators.pattern(/^\d+$/), Validators.min(0)],
        customErrorMessage: 'Thứ tự sort phải là số nguyên không âm'
      },
      {
        key: 'colorPreset',
        label: 'Bộ màu có sẵn',
        type: 'colorpreset',
        width: 'full',
        config: DEFAULT_COLOR_PRESET_CONFIG,
        showDividerAfter: true
      },
      {
        key: 'tagColor',
        label: 'Màu nền thẻ',
        type: 'colorpicker',
        width: 'half',
        config: DEFAULT_TAG_COLOR_CONFIG,
        dependsOn: 'colorPreset'
      },
      {
        key: 'tagTextColor',
        label: 'Màu chữ thẻ',
        type: 'colorpicker',
        width: 'half',
        config: DEFAULT_TAG_TEXT_COLOR_CONFIG,
        dependsOn: 'colorPreset'
      }
    ]
  };
};
